import { Component, Input, OnInit, Output, EventEmitter, KeyValueDiffers } from '@angular/core';

import { IValueChangedEvent } from '../../../wizard.content';
import { filter, find, forEach } from 'lodash';
@Component({
  selector: 'wizard-user-from-group',
  templateUrl: './fusion.sso.user.from.group.html',
  styleUrls: ['../wizard.user.style.scss'],
  providers: []
})
export class FusionSsoUserFromGroupComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() step: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() subStep: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  wizardService: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  grouplist: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedAll: any;
  constructor(public differs: KeyValueDiffers) {
    this.differs = differs;
  }

  ngOnInit() {
    this.wizardService = this.wizardCtrl.wizardService;
    this.grouplist = this.step.parent.defaultParamsById.groupIds;
    this.checkCurrentUser();
    this.selectedAll = {
      isChecked: false
    };
  }

  checkCurrentUser(): void {
    const userName = this.step.parent.defaultParamsById.userNames[0];
    const isCurrentUser = this.wizardService.isCurrentUser(userName);
    const manageUserId = 'manageUsersPermissions';
    if (isCurrentUser) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      forEach<any>(this.grouplist, group => {
        if (find(group.roles, role => role.name === manageUserId)) {
          group.disabled = true;
        }
      });
    }
  }

  flipValues(): void {
    this.selectedAll.isChecked = !this.selectedAll.isChecked;
    this.selectAllGroup();
    this.onDataValueChange.emit({
      componentId: 'add_users_to_groups',
      key: 'groupId',
      newValue: filter(this.grouplist, { isChecked: true }),
      isValid: true
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  flipValue(group: any): void {
    if (!group.disabled) {
      this.selectGroup(group);
    }
    this.onDataValueChange.emit({
      componentId: 'add_users_to_groups',
      key: 'groupId',
      newValue: filter(this.grouplist, { isChecked: true }),
      isValid: true
    });
  }

  clickDetected(): boolean {
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  selectGroup(group: any): void {
    group.isChecked = !group.isChecked;
    this.selectAllChechdValue();
  }
  selectAllGroup(): void {
    forEach(this.grouplist, item => {
      if (!item.disabled) {
        item.isChecked = this.selectedAll.isChecked;
      }
    });
  }
  selectAllChechdValue(): void {
    const data = filter(this.grouplist, { isChecked: true });
    this.selectedAll.isChecked = false;
    if (data.length == this.grouplist.length) {
      this.selectedAll.isChecked = true;
    }
  }

  isLoading(): boolean {
    return this.wizardService.isLoading;
  }
}
